
import axios from 'axios'
import getConfig from 'next/config'

const publicRuntimeConfig = getConfig()?.publicRuntimeConfig
const envs = publicRuntimeConfig?.processEnv

const API = axios.create({
  baseURL: envs?.NEXT_PUBLIC_ORIGIN_BASE,
})

export const FlightAPI = axios.create({
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json, text/javascript', 'Access-Control-Allow-Origin': '*', 'X-Requested-With': 'XMLHttpRequest' },
})

FlightAPI.interceptors.request.use((config) => {
  // Timeout'u 10 saniyeye çıkarıyoruz (upstream request timeout için)
  // Eğer config'de zaten timeout set edilmişse onu kullan, yoksa 10000ms kullan
  config.timeout = 10000
  return config
})

export const CampaginAPI = axios.create({ baseURL: 'https://www.enuygun.com/campaign-api/graphql' })

export const BilgiAPI = axios.create({ baseURL: 'https://www.enuygun.com' + '/content/', headers: { ACCEPT: 'image/webp' } })

export const HomepageAPI = axios.create({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json, text/javascript', 'Access-Control-Allow-Origin': '*' } })

export const InformationContentAPI = axios.create({
  baseURL: 'https://information-content-admin.sonsomon.com/information-content-api/graphql',
  headers: {
    'Content-Type': 'application/json',
    'Authorization':
      'Bearer fa69d6a2f9b987e5a42f4f831771ffdf5110bf98cb6f5287771e2d3b545736469c6b08cc794ac7a840b62a039d6df70ffc1d1cda2572769a47abc5d13b00a9212cd486026752955072c990fbd190306fd0859123bef7663be971652b71851c94a69b658d2890a393f653f17e851698d6912c8726e451691fb757a8347ca6ebb3',
    'Access-Control-Allow-Origin': '*', // Required for CORS support to work
  },
})

export default API
